import React, { useEffect, useState } from 'react';
import { Container, Title, SubTitle } from './styles';
import { Col, Row } from 'react-bootstrap';
import InputGeral from '../../../../components/InputGeral/Index';
import SubmitForm from "../../../../components/SubmitForm";
import { ConsultaTotvsEmpresa } from '../../../../../backend/ConsultaTotvsEmpresa';
import { useParams } from 'react-router-dom';
import { decryptAES, ErroMsg, SucessoMsg } from '../../../../contents/VariaveisGlobais';
import SelectFixo from '../../../../components/SelectFixo';
import { usePopUp } from '../../../../components/BootBox';
import ConsumoTOTVS_POST from '../../../../../backend/ConsumoTotvs';
import UploadFiles from '../../../../components/UploadFiles';
import { toast } from 'react-toastify';
import { ConsumoAPI_FileUpload } from '../../../../../backend/ConsumoAPI';
import { format } from 'date-fns';
import LoadingSpinner from '../../../../components/LoadinSpinner';
import HomologacaoFornecedores from "../../../../../lib/json/consultas/HomologacaoFornecedores.json"

const HomologacaoFornecedor = ({dadosFornecedor, dadosHomologacao}) => {
	const currentDate = new Date()

	const [carregar, setCarregar] = useState(false);
	const [visibleForm, setVisibleForm] = useState(false);
	const [disabledForm, setDisabledForm] = useState(false);
	const [empresaFilial, setEmpresaFilial] = useState();
	const [optionsResposta, setOptionsResposta] = useState([{value: '0', text: 'Não'},{value: '4', text: 'Parcialmente'},{value: '8', text: 'Sim'}]);
	const [optionsRespostaDocumental, setOptionsRespostaDocumental] = useState([{value: '0', text: 'Não'},{value: '1', text: 'Sim'}]);
	
	const [media, setMedia] = useState(0);

	const [campoFornecedor, setCampoFornecedor] = useState();
	const [campoLoja, setCampoLoja] = useState();
	const [campoNome, setCampoNome] = useState();
	const [campoContato, setCampoContato] = useState();
	const [campoProfissional, setCampoProfissional] = useState();
	const [campoTelefone, setCampoTelefone] = useState();
	const [campoArea, setCampoArea] = useState();
	const [campoEnvio, setCampoEnvio] = useState(format(currentDate, 'yyyy-MM-dd'));

	const [campoPrazo, setCampoPrazo] = useState();
	const [campoExigencia, setCampoExigencia] = useState();
	const [campoSuporte, setCampoSuporte] = useState();
	const [campoComprometimento, setCampoComprometimento] = useState();
	const [campoEspecificacoes, setCampoEspecificacoes] = useState();
	const [campoISO9001, setCampoISO9001] = useState();
	const [campoISO45001, setCampoISO45001] = useState();
	const [campoAnexoISO9001, setCampoAnexoISO9001] = useState([]);
	const [campoAnexoISO45001, setCampoAnexoISO45001] = useState([]);
	
	const { '*' : HomologacaoTela } = useParams();
	const { DisparaBootBox, FechaBootBox } = usePopUp();
	
	useEffect( () => {
		const fetchData = async() => {
			setCarregar(true)
			let dadosFornecedorURL = []
			let habilitaDigitacao = true

			if (HomologacaoTela){
				const secretKeyCotacao = window._env_?.REACT_APP_KEY_COTACAO
                const cotacaoDecrypt = decryptAES(HomologacaoTela, secretKeyCotacao)
                
                dadosFornecedorURL = JSON.parse(cotacaoDecrypt)
				habilitaDigitacao = false;
			}

			const dadosTela = dadosFornecedor || dadosFornecedorURL;
			if (dadosTela?.Filial){
				const empresaLogada = dadosTela.Filial
				setEmpresaFilial(empresaLogada)
				setCampoFornecedor(dadosTela.Fornecedor)
				setCampoLoja(dadosTela.Loja)
				setCampoContato(dadosTela.Contato)

				const consultaDefault = `SELECT A2_NOME, A2_MEDIA, A2_XTPFORN FROM TABELA(SA2) WHERE D_E_L_E_T_ <> '*' AND A2_COD = '${dadosTela.Fornecedor}' AND A2_LOJA = '${dadosTela.Loja}'`
				//Processa Consulta SA2 para ver se já está homologado e pra capturar Nome Fornecedor
				
				var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, "SA2", empresaLogada );
				if (retConsulta.data){
					const dadosTabela = retConsulta.data[0]
					const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO
					const lHomologado = dadosTabela.A2_XTPFORN === 'N' || ( dadosTabela.A2_XTPFORN !== 'N' && dadosTabela.A2_MEDIA >= nMediaHomologado )

					setVisibleForm(!lHomologado)
					setDisabledForm(lHomologado)
					setCampoNome(dadosTabela.A2_NOME)
					setMedia(dadosTabela.A2_MEDIA)
				}
			}else{
				if (dadosHomologacao){
					const { EMPRESA, M0_CODFIL, PTQ_NUM, PTQ_NUMQUE, A2_COD, A2_LOJA, A2_NOME, PTQ_PROFI, PTQ_TELPRO, PTQ_AREA } = dadosHomologacao
					const empresaLogada = EMPRESA + '' + M0_CODFIL
					
					setVisibleForm(true)
					setDisabledForm(true)
					setEmpresaFilial(empresaLogada)
					setCampoFornecedor(A2_COD)
					setCampoLoja(A2_LOJA)
					setCampoNome(A2_NOME)
					setCampoContato(PTQ_PROFI)
					setCampoTelefone(PTQ_TELPRO)
					setCampoArea(PTQ_AREA)

					let consultaDefault = HomologacaoFornecedores.consulta
					consultaDefault = consultaDefault.replace('CAMPOS', " PTQ.*, CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),PTQ_ANEXOS))) PTQ_ANEXOS ")
					consultaDefault = consultaDefault.replace('FILTRO', "AND PTQ_NUM = '" + PTQ_NUM + "' AND PTQ_NUMQUE = '" + PTQ_NUMQUE + "' AND PTQ_FORNEC = '" + A2_COD + "' AND PTQ_LOJA = '" + A2_LOJA + "'")

					var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, HomologacaoFornecedores.tabelas, empresaLogada );
					if (retConsulta.data){
						retConsulta.data.map((item) => {
							const oOpcao = item.PTQ_OPCOE.trim().split(';').map((itemOpcao) => itemOpcao.split(','));
							const cTextOption = oOpcao.filter((itemOpcao) => Number(itemOpcao[2]) == item.PTQ_NOTA)[0][1]

							switch (item.PTQ_PERG.trim()) {
								case "CUMPRE OS PRAZOS E QUANTIDADES PREVIAMENTE ACORDADAS?" :
									setCampoPrazo({value: item.PTQ_NOTA, text: cTextOption})
									break;

								case "CUMPRE AS EXIGÊNCIAS SOCIO AMBIENTAIS?" :
									setCampoExigencia({value: item.PTQ_NOTA, text: cTextOption})
									break;

								case "FORNECE ASSISTÊNCIA TÉCNICA / SERVIÇOS PÓS VENDAS, QUANDO NECESSÁRIO?" :
									setCampoSuporte({value: item.PTQ_NOTA, text: cTextOption})
									break;

								case "POSSUI COMPROMETIMENTO COM A SAÚDE E SEGURANÇA DOS PROFISSIONAIS, INCLUINDO ATENDIMENTO AOS REQUISITOS (LEGAIS E CORPORATIVOS)?" :
									setCampoComprometimento({value: item.PTQ_NOTA, text: cTextOption})
									break;

								case "OS PRODUTOS ATENDEM ÀS ESPECIFICAÇÕES TÉCNICAS (QUALIDADE DO PRODUTO)?" :
									setCampoEspecificacoes({value: item.PTQ_NOTA, text: cTextOption})
									break;

								case "POSSUI ISO 9001 ?" :
									const cAnexo9001 = item.PTQ_ANEXOS.trim() || "[]"	
									setCampoISO9001({value: item.PTQ_NOTA, text: cTextOption})
									setCampoAnexoISO9001(JSON.parse(cAnexo9001))
									break;
								
								case "POSSUI ISO 45001 ?" :
									const cAnexo45001 = item.PTQ_ANEXOS.trim() || "[]"
									setCampoISO45001({value: item.PTQ_NOTA, text: cTextOption})
									setCampoAnexoISO45001(JSON.parse(cAnexo45001))
									break;
								default:
									break;
							}
						})
					}
				}
			}

			setCarregar(false)
        }

        fetchData()
    }, []);

	const handleEnviar = async() => {
		setCarregar(true)
		const objSalvar = {
			fornecedor: campoFornecedor,
			loja: campoLoja,
			nome: campoNome,
			contato: campoContato,
			profissional: campoProfissional,
			telefone: campoTelefone,
			area: campoArea,
			dataEnvio: campoEnvio,
			perguntas: [
				{
					descricao: "CUMPRE OS PRAZOS E QUANTIDADES PREVIAMENTE ACORDADAS?",
					opcoes: "S,SIM,8;N,NÃO,0;PA,PARCIALMENTE,4",
					resposta: campoPrazo?.value || "0",
					anexo: '',
				},
				{
					descricao: "CUMPRE AS EXIGÊNCIAS SOCIO AMBIENTAIS?",
					opcoes: "S,SIM,8;N,NÃO,0;PA,PARCIALMENTE,4",
					resposta: campoExigencia?.value || "0",
					anexo: '', 
				},
				{
					descricao: "FORNECE ASSISTÊNCIA TÉCNICA / SERVIÇOS PÓS VENDAS, QUANDO NECESSÁRIO?",
					opcoes: "S,SIM,8;N,NÃO,0;PA,PARCIALMENTE,4",
					resposta: campoSuporte?.value || "0",
					anexo: '', 
				},
				{
					descricao: "POSSUI COMPROMETIMENTO COM A SAÚDE E SEGURANÇA DOS PROFISSIONAIS, INCLUINDO ATENDIMENTO AOS REQUISITOS (LEGAIS E CORPORATIVOS)?",
					opcoes: "S,SIM,8;N,NÃO,0;PA,PARCIALMENTE,4",
					resposta: campoComprometimento?.value || "0",
					anexo: '', 
				},
				{
					descricao: "OS PRODUTOS ATENDEM ÀS ESPECIFICAÇÕES TÉCNICAS (QUALIDADE DO PRODUTO)?",
					opcoes: "S,SIM,8;N,NÃO,0;PA,PARCIALMENTE,4",
					resposta: campoEspecificacoes?.value || "0",
					anexo: '', 
				},
				{
					descricao: "POSSUI ISO 9001 ?",
					opcoes: "S,SIM,1;N,NÃO,0",
					resposta: campoISO9001?.value || "0",
					anexo: JSON.stringify(campoAnexoISO9001),
				},
				{
					descricao: "POSSUI ISO 45001 ?",
					opcoes: "S,SIM,1;N,NÃO,0",
					resposta: campoISO45001?.value || "0",
					anexo: JSON.stringify(campoAnexoISO45001),
				}
			],
			media
		}
		const jsonSalvar = JSON.stringify(objSalvar)

		let oRetorno

		oRetorno = await ConsumoTOTVS_POST('PREENCHEHOMOLOGACAO', jsonSalvar, empresaFilial)
        
		setCarregar(false)

        if (oRetorno.error === '00'){
            SucessoMsg("Dados Gravados com Sucesso!!!")
			setDisabledForm(true)
        }else{
            ErroMsg(oRetorno.description)
        }

		return false
	}

	const handleAddFilesISO9001 = async(acceptedFiles, fileRejections, event) => {
		const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
		const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

		if (!isValidFileType) {
			toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
			return;
		}

		const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
		
		if (event){
			event.persist()
			event.preventDefault()
		}

		if (retUpload.error === "00") {
			const newFiles = retUpload.data.map(file => file);
			const filesUpload = [...campoAnexoISO9001, ...newFiles]
			setCampoAnexoISO9001(filesUpload)

			return filesUpload;
		}
	}

	const handleAddFilesISO45001 = async(acceptedFiles, fileRejections, event) => {
		const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
		const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

		if (!isValidFileType) {
			toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
			return;
		}

		const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
		
		if (event){
			event.persist()
			event.preventDefault()
		}

		if (retUpload.error === "00") {
			const newFiles = retUpload.data.map(file => file);
			const filesUpload = [...campoAnexoISO45001, ...newFiles]
			setCampoAnexoISO45001(filesUpload)

			return filesUpload;
		}
	}
		
	useEffect( () => {
		const nSomaMedia = parseFloat(campoComprometimento?.value || "0") + 
						   parseFloat(campoEspecificacoes?.value || "0") + 
						   parseFloat(campoExigencia?.value || "0") + 
						   parseFloat(campoSuporte?.value || "0") + 
						   parseFloat(campoPrazo?.value || "0");

		const totalMedia = nSomaMedia / 5;
		
		if (totalMedia < 4){
			setCampoISO9001()
			setCampoISO45001()
			setCampoAnexoISO9001([])
			setCampoAnexoISO45001([])
		}
		
		const totalMediaFinal = totalMedia + 
								parseFloat(campoISO9001?.value || "0") + 
								parseFloat(campoISO45001?.value || "0");
		setMedia(totalMediaFinal);
	}, [campoComprometimento, campoEspecificacoes, campoExigencia, campoSuporte, campoPrazo, campoISO9001, campoISO45001])

  	return (
		<>
			<Container>
				<LoadingSpinner isLoading={carregar}/>
				<Title>{`Homologação de Fornecedor`}</Title>
				<div className="container mt-4">
					<Row>
						<Col md="6">
							<InputGeral
								label={"Fornecedor"}
								tipo={"text"}
								value={campoNome}
								disabled={true}
							/>
						</Col>
						<Col md="3">
							<InputGeral
								label={"Contato"}
								tipo={"text"}
								value={campoContato}
								disabled={campoContato && campoContato.trim() && true}
							/>
						</Col>
						{ visibleForm && 
							<Col md="3">
								<InputGeral
									label={"Profissional"}
									tipo={"text"}
									value={campoProfissional}
									onChange={(e) => setCampoProfissional(e.target.value)}
									disabled={disabledForm}
								/>
							</Col>
						}
					</Row>
					{ visibleForm && 
						<Row>
							<Col md="3">
								<InputGeral
									label={"Telefone"}
									tipo={"text"}
									value={campoTelefone}
									onChange={(e) => setCampoTelefone(e.target.value)}
									disabled={disabledForm}
								/>
							</Col>
							<Col md="6">
								<InputGeral
									label={"Àrea / Obra / Parceiro"}
									tipo={"text"}
									value={campoArea}
									onChange={(e) => setCampoArea(e.target.value)}
									disabled={disabledForm}
								/>
							</Col>
							<Col md="3">
								<InputGeral
									label={"Data de Envio Questionário"}
									tipo={"date"}
									value={campoEnvio}
									disabled={true}								
								/>
							</Col>
						</Row>
					}
				</div>
				{ visibleForm && 
					<div className="container mt-4">
						<SubTitle>Pesquisa de Fornecedor</SubTitle>
						<Row>
							<Col md="6">
								<SelectFixo
									onChange={setCampoPrazo}
									value={campoPrazo}
									selectedOptionValue={campoPrazo}
									isLabel={true}
									label={"CUMPRE OS PRAZOS E QUANTIDADES PREVIAMENTE ACORDADAS?"}
									tipo={"text"}
									options={optionsResposta}
									disabled={disabledForm}
								/>
							</Col>
							<Col md="6">
								<SelectFixo
									onChange={setCampoExigencia}
									value={campoExigencia}
									selectedOptionValue={campoExigencia}
									isLabel={true}
									label={"CUMPRE AS EXIGÊNCIAS SOCIO AMBIENTAIS?"}
									tipo={"text"}
									options={optionsResposta}
									disabled={disabledForm}
								/>
							</Col>
						</Row>
						<Row>
							<Col md="12">
								<SelectFixo
									onChange={setCampoSuporte}
									value={campoSuporte}
									selectedOptionValue={campoSuporte}
									isLabel={true}
									label={"FORNECE ASSISTÊNCIA TÉCNICA / SERVIÇOS PÓS VENDAS, QUANDO NECESSÁRIO?"}
									tipo={"text"}
									options={optionsResposta}
									disabled={disabledForm}
								/>
							</Col>
							<Col md="12">
								<SelectFixo
									onChange={setCampoComprometimento}
									value={campoComprometimento}
									selectedOptionValue={campoComprometimento}
									isLabel={true}
									label={"POSSUI COMPROMETIMENTO COM A SAÚDE E SEGURANÇA DOS PROFISSIONAIS, INCLUINDO ATENDIMENTO AOS REQUISITOS (LEGAIS E CORPORATIVOS)?"}
									tipo={"text"}
									options={optionsResposta}
									disabled={disabledForm}
								/>
							</Col>
							<Col md="12">
								<SelectFixo
									onChange={setCampoEspecificacoes}
									value={campoEspecificacoes}
									selectedOptionValue={campoEspecificacoes}
									isLabel={true}
									label={"OS PRODUTOS ATENDEM ÀS ESPECIFICAÇÕES TÉCNICAS (QUALIDADE DO PRODUTO)?"}
									tipo={"text"}
									options={optionsResposta}
									disabled={disabledForm}
								/>
							</Col>
						</Row>
					</div>
				}
				{ media >= 4 && visibleForm && 
					<div className="container mt-4">
						<SubTitle>Avaliação Documental</SubTitle>
						<Row>
							<Col md="6">
								<SelectFixo
									onChange={setCampoISO9001}
									value={campoISO9001}
									selectedOptionValue={campoISO9001}
									isLabel={true}
									label={"POSSUI ISO 9001 ?"}
									tipo={"text"}
									options={optionsRespostaDocumental}
									disabled={disabledForm}
								/>
							</Col>
							{  campoISO9001 && campoISO9001.value === 1 && 
								<Col md="6">
									<UploadFiles
										onDropEvent={handleAddFilesISO9001}
										value={campoAnexoISO9001}
										disabled={disabledForm}
									/>
								</Col>
							}
						</Row>
						<Row>
							<Col md="6">
								<SelectFixo
									onChange={setCampoISO45001}
									value={campoISO45001}
									selectedOptionValue={campoISO45001}
									isLabel={true}
									label={"POSSUI ISO 45001 ?"}
									tipo={"text"}
									options={optionsRespostaDocumental}
									disabled={disabledForm}
								/>
							</Col>
							{ campoISO45001 && campoISO45001.value === 1 && 
								<Col md="6">
									<UploadFiles
										onDropEvent={handleAddFilesISO45001}
										value={campoAnexoISO45001}
										disabled={disabledForm}
									/>
								</Col>
							}
						</Row>
					</div>
				}

				<div className="container mt-4">
					<Row>
						<Col md="10"></Col>
						<Col md="2">
							<InputGeral
								label={"Média Geral: "}
								tipo={"numero"}
								value={media}
								disabled={true}
							/>
						</Col>
					</Row>
				</div>

				<div className="container mt-4">
					<SubmitForm
						onEnviar={ visibleForm && !disabledForm ? handleEnviar: null}
					/>
				</div>
			</Container>
		</>
  	);
};

export default HomologacaoFornecedor;
